import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const Swal;

@Component({
  selector: 'app-edit-parking',
  templateUrl: './edit-parking.component.html',
  styleUrls: ['./edit-parking.component.css']
})
export class EditParkingComponent implements OnInit {
  
  @ViewChild('modalHide') modalHide;

  public editParkingForm:FormGroup;
  public parkingLocation = {};
  public selectedValueClose = false;
  public locationSuggestions = {};
  public fieldOptions=[{
    branch:[],
  }];
  public parkingInformation=[];
  public branchInformation=[];
  
  public locationObj = {};

  primaryMap: any;
  mapSearchDebounceTimeOut = null;
  mapSearchDataLists = [];
  markerId = 'parkingLocation';

  public parkingID;
  public orgID;
  public updateValues=[];
  public updateLocation:boolean=false;

  public editLocation:boolean=true;
  public locationData = {};
  formSubmit:boolean=false;
  
  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public route: ActivatedRoute)
    {
      this.orgID= this.storage.get('userInfo').orgID;
      this.route.paramMap.subscribe((params: any) => {
        this.parkingID=params.params.id;
      });
  }

  ngOnInit(): void {
    this.editParkingLoad();
    this.getBranchList();

    /* this.loadMap();
    this.scrollToPageTop(); */

    setTimeout(()=>{
      this.getParkingData();
    },500)

  }
  /* API */
  getParkingData(){
    const obj = {
        orgID: this.orgID,
        parkingID: this.parkingID
    };
    this.api.transportManagerParkingList(obj).then((res: any) => {
        if (res.status == 'success') {
            const data = res.data[0];
            this.parkingInformation=res.data[0];
            this.setValueEditParkingForm(this.parkingInformation);
        }  
    }).catch((err) => {
        console.log(err);
    });
  }
  getBranchList() {
    const obj = {
      orgID: this.orgID,
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.branchInformation = res.data;
        this.addBranchOptions();
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  addBranchOptions(){
    if(this.branchInformation && this.branchInformation.length>0){
      this.branchInformation.filter((e)=>{
        let option={name:e.branchName,value:e.branchID};
        this.fieldOptions[0].branch.push(option);
      });
    }
  }

  editParkingLoad(){
    this.editParkingForm = new FormGroup({
      title : new FormControl('', [Validators.required]),
      location : new FormControl('', [Validators.required]),
      branch : new FormControl('', [Validators.required]),
      isEnable : new FormControl('', [Validators.required]),
      radius : new FormControl('', [Validators.required]),
    });
  }
  setValueEditParkingForm(data){
    this.editParkingForm.patchValue({
      title : data.title ? data.title : '',
      location: data.location && data.location.name ? data.location.name :'',
      branch : data.branch ? data.branch : '',
      isEnable : data.isEnable == 0  ? String(data.isEnable):'1',
      radius : data.radius ? data.radius : 100,
    });
    this.locationData = { ...data.location};
    console.log(this.locationData);
  }

  getLocation(obj){
    console.log(obj);
    this.parkingLocation = {...obj};
    this.fieldChange(this.parkingLocation,'location','location'); 
  }

  /* checking error in fields*/
  public checkError = (controlName: string, errorName: string) => {
    return this.editParkingForm.controls[controlName].hasError(errorName);
  }
   /* update unique field*/
  fieldChange(e:any,type,field){
    if(type=='location'){
      this.updateField(field,e);
    }
    else if(type=='dropdown'){
      console.log(field,typeof(e.value));
      this.updateField(field,e.value);
    }
    else{
      this.updateField(field,e.target.value);
    }
  }
  updateField(field,value){
    console.log(field,value);
    if(this.updateValues.length>0){
      let filterUpdate=this.updateValues.filter((e)=>e.field!=field);
      let obj={field:field,value:value,};
      this.updateValues=[
        ...filterUpdate,
        obj,
      ]
    }
    else{
      let obj={field:field,value:value,};
      this.updateValues.push(obj);
    }
  }
  /* Delete Data*/
  delete() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor:  '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('delete click');
        this.deleteParking();
        Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        );
      }
    });
  }
  deleteParking() {
    const obj = {
      orgID: this.orgID,
      parkingID: this.parkingID
    };
    console.log(obj);
    this.api.transportManagerParkingDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 20000);
        this.router.navigate(['/organization/transport-manager/information/orgInfo/parking/view-parking']);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 20000);
      }
    });
  }
  /* Cancel Edit*/
  cancel(){
    this.router.navigate(['/organization/transport-manager/information/orgInfo/parking/view-parking']);
  }

  /* submit data*/
  onSubmit(){
    this.formSubmit = true;
    if(this.updateValues && this.updateValues.length>0){
      const obj = {
        orgID: this.orgID,
        parkingID: this.parkingID
      };
      console.log(this.updateValues);
      this.updateValues.filter((e)=>{
            if(e.field=='isEnable'){
              obj[e.field]=Number(e.value);
              //obj[e.field]=e.value;
            }
            else{
              obj[e.field]=e.value;
            }
      });
      console.log(obj);
      this.api.transportManagerParkingUpdate(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/parking/view-parking'])
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }

}
